import { Formik } from "formik";
import {validateWelcomePopup } from "../../constant/validation";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { onlyNumber } from "../../constant/utils";
import { validateGeneralEnquiry } from "../../constant/validation";
import { submitAction } from "../../redux/action";
import { useLocation } from "react-router-dom";
import { ROUTE } from "../../route/Route";
import { boolean } from "yup";
import Recaptcha from "../../Component/ReCaptcha";

const initialValue = {
  Name: "",
  Email: "",
  Mobile: "",
  Message: "",
  CityId: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false ,
  GRecaptcha: "",
};

const WelcomePopup = (props: any) => {
  const [showPopup, setShowPopup] = useState(true);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const cityData = useSelector((state: any) => state.dashboard.cityAll);

  const closePopup = () => {
    setShowPopup(false);
  };
  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 8000); 
    const handleBeforeUnload = () => {
      localStorage.setItem("op:hcOpenTime", new Date()?.toString());
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      clearTimeout(timer);
    };
  }, []);

  if (!showPopup || loading) {
    return null;
  }

  const handleSubmit = (values: any) => {
    let val: any = { ...values };
    val.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    val.UtmSource = urlParams.get("utm_source");
    val.UtmMedium = urlParams.get("utm_medium");
    val.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.submitEnquiryAction(val, history));
    setShowPopup(false);
  };
  return (
    <div className="modal welcome-modal fix-modal" role="dialog">
      <div className="modal-dialog for-modal-top" role="document">
        <div className="modal-content">
          <div className="modal-header modal-header-pb">
            <div className="pop-up-content">
              <h5 className="modal-title">Blood Sample Collection from Home</h5>
              <p>Drop your details to book your blood sample collection</p>
            </div>
            <div className="pop-up-img">
              <img src="/assets/img/pop-up-img.webp" className="scale round_img" alt="" />
            </div>
            <button
              type="button"
              onClick={closePopup}
              className="close cust-pop-close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" className="model-btn-pop pointer">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body-n">
            <div className="h-services h-services-pop mt-0-pop">
              <div className="infobox_wrapper">
                <Formik
                  initialValues={initialValue}
                  enableReinitialize={true}
                  validationSchema={validateWelcomePopup}
                  onSubmit={(val: any) => {
                    handleSubmit(val);
                  }}
                  render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }:any) => (
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <input
                          type="text"
                          name="Name"
                          className="form-control"
                          placeholder={t("name_optional")}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.Name}
                        />
                        {touched?.Name && errors?.Name && <span className="error_message">{t(errors?.Name)}</span>}
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="Mobile"
                          className="form-control"
                          placeholder={t("mobile_number")}
                          onKeyPress={onlyNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.Mobile}
                        />
                        {touched?.Mobile && errors?.Mobile && (
                          <span className="error_message">{t(errors?.Mobile)}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="CityId"
                          id="CityId"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.CityId}
                        >
                          <option value="">{t("city")}*</option>
                          {cityData &&
                            cityData.length > 0 &&
                            cityData?.map((item: any, i: any) => (
                              <option value={item?.Id} key={i} className="text-uppercase">
                                {t(item?.Name)}
                              </option>
                            ))}
                        </select>
                        {touched?.CityId && errors?.CityId && (
                          <span className="error_message">{t(errors?.CityId)}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("email")}
                          name="Email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.Email}
                        />
                        {touched?.Email && errors?.Email && <span className="error_message">{errors?.Email}</span>}
                      </div>
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          placeholder={t("message")}
                          name="Message"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.Message}
                        ></textarea>
                        {touched?.Message && errors?.Message && (
                          <span className="error_message">{t(errors?.Message)}</span>
                        )}
                      </div>
                      {/* <div className="d-flex">
                          <input type="checkbox" name="Checkbox" onChange={handleChange} onBlur={handleBlur}  value={values?.Checkbox} />
                          <div className="m-2">
                          By clicking you accept to the <a className="text-info" href="https://oncquestlabs.com/terms-condition">terms and conditions</a> and the <a className="text-info" href="https://oncquestlabs.com/privacy-policy">Privacy Policy.</a></div>
{touched?.Checkbox && errors?.Checkbox && (
                              <span className="error_message">
                                {t(errors?.Checkbox)}
                                
                                
                              </span>
                            )}
                        </div> */}
                      <div className="d-flex for-check-style">
                        <input type="checkbox" name="Checkbox" onChange={handleChange} id="checkbox_id" />
                        <label className="mx-2" htmlFor="checkbox_id">
                          By clicking you accept to the{" "}
                          <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                            terms and conditions
                          </a>{" "}
                          and the{" "}
                          <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                            Privacy Policy.
                          </a>
                        </label>
                      </div>
                      <div className="error_message">
                        {errors.Checkbox ? <p className="error_message">{errors.Checkbox}</p> : null}
                      </div>
                      <button type="submit" className="book--hexagon active">
                        <span>
                          {t("submit_btn")}
                          <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                        </span>
                      </button>
                    </form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;
